<template>
  <div>
    <ods-form :model="datosTerminales" :rules="ticketRules" ref="datosTerminales">
      <div class="default-form">
        <ods-dialog
            @open="openModify"
            :visible.sync="isVisible"
            :before-close="handleCloseTerm"
            width="50%"
            :append-to-body="true">
                <ods-row class="grid-content bg-purple detalle-usarioa-al">
                  <ods-col :span="18">
                    <span>DETALLE TERMINAL</span>
                  </ods-col>
                  <ods-col class="text-button" :span="6" :offset="0">
                    <span @click="habEditar()">EDITAR</span>
                  </ods-col>
                </ods-row>
            <ods-row :gutter="10" style="margin-top: 3%">
              <ods-col :span="8">
                <ods-form-item label="Terminal" prop="codterm">
                    <ods-select :disabled="deshabilitaTerminal" v-model="datosTerminales.codterm" size="hecto" id="idcodterm">
                      <ods-option
                        v-for="item in this.listCodterm"
                        :key="item.codterm"
                        :value="item.codterm + ' - '+ item.dattpv">
                      </ods-option>
                    </ods-select>
                </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item label="Descripción" prop="texto">
                  <ods-input
                    :disabled="deshabilitaDescripcion"
                    v-model="datosTerminales.texto"
                    size="hecto"></ods-input>
                  </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item label="Usuario" prop="usuario">
                    <ods-select :disabled="deshabilitaUsuario" v-model="datosTerminales.usuario" size="hecto">
                      <ods-option
                        v-for="item in this.listadoUsuarios"
                        :key="item.usuario"
                        :value="item.usuario">
                      </ods-option>
                    </ods-select>
                </ods-form-item>
              </ods-col>
            </ods-row>
              <span slot="footer" class="dialog-footer">
                <ods-button style="position: absolute; right: 7%; margin-top: -2%;" size="medium" type="secondary;" @click="onSubmit(datosTerminales, 'datosTerminales')">guardar
                </ods-button>
              </span>
        </ods-dialog>
      </div>
    </ods-form>
      <dialog-generic-error
        :message="errorMessage"
        :dialogError="dialogError"
        :before-close-fn="handleCloseSession"
        @dialogClosed="closeDialogError($event)">
      </dialog-generic-error>
      <dialog-generic-success
        :dialogSuccess="dialogSuccess"
        @dialogClosed="closeDialogSuccess($event)">
      </dialog-generic-success>
      <dialog-generic-warning
        :message="warningMessage"
        :dialogWarning="dialogWarning"
        @dialogClosed="closeDialogWarning($event)">
      </dialog-generic-warning>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogGenericError from '@/components/dialogs/DialogGenericError'
import DialogConfirmSuccess from '@/components/dialogs/DialogConfirmSuccess'
import DialogGenericWarning from '@/components/dialogs/DialogGenericWarning'
export default {
  props: ['codcomercio', 'desdescomercio', 'isVisible', 'rowModify'],
  data () {
    var validateTerminal = (rule, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('Por favor, introduce un terminal'))
      } else {
        callback()
      }
    }
    var validateDescripcion = (rule, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('Por favor, introduce la descripción'))
      } else {
        callback()
      }
    }
    return {
      dialogTableVisible: false,
      deshabilitaTerminal: true,
      deshabilitaDescripcion: true,
      deshabilitaUsuario: true,
      datosTerminales: {
        codterm: '',
        texto: '',
        usuario: '',
        codcom: ''
      },
      dialogError: false,
      dialogSuccess: false,
      dialogWarning: false,
      hasErrors: false,
      errorMessage: '',
      warningMessage: '',
      ticketRules: {
        codterm: [
          { required: false, validator: validateTerminal, trigger: 'blur' }
        ],
        texto: [
          { required: false, validator: validateDescripcion, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onSubmit (datosTerminales, nombreTerminal) {
      this.datosTerminales.codterm = this.datosTerminales.codterm.toString().substring(0, 4)
      this.datosTerminales.codcom = this.codcomercio
      this.datosTerminales.nomcomred = this.desdescomercio
      this.$refs[nombreTerminal].validate((valid) => {
        if (valid) {
          this.$store.dispatch('modTpv', datosTerminales).then(r => {
            this.refreshListTerminal()
            this.handleCloseTerm()
            if (r.error === true) {
              this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
            } else if (r.warning === true) {
              this.displayErrorWarning(r.data.runServiceResponse.return.descRetorno)
            } else {
              this.displayConfirmSuccess()
            }
          }).catch(e => {
            console.error('Error in list Users - App', e)
          })
        }
      })
    },
    handleCloseTerm () {
      this.dialogTableVisible = false
      this.$emit('closingDialog', this.dialogTableVisible)
      this.deshabilitaTerminal = true
      this.deshabilitaDescripcion = true
      this.deshabilitaUsuario = true
    },
    openModify () {
      this.datosTerminales.codterm = this.rowModify.codterm
      this.datosTerminales.texto = this.rowModify.texto
      this.datosTerminales.usuario = this.rowModify.usuario
      this.datosTerminales.codcom = this.rowModify.codcom
    },
    handleCloseSession () {
      this.$store.dispatch('logout')
    },
    closeDialogError (e) {
      this.dialogError = e
      this.handleCloseSession()
    },
    closeDialogSuccess (e) {
      this.dialogSuccess = e
    },
    closeDialogWarning (e) {
      this.dialogWarning = e
    },
    displayErrorDialog (msg) {
      this.errorMessage = `${msg}`
      this.dialogError = true
    },
    displayConfirmSuccess () {
      this.dialogSuccess = true
    },
    displayErrorWarning (msg) {
      this.warningMessage = `${msg}`
      this.dialogWarning = true
    },
    refreshListTerminal () {
      this.$store.dispatch('listTpv', { codcom: this.codcomercio }).then(r => {
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        }
      }).catch(e => {
        console.error('Error in list TPVS - App', e)
      })
    },
    habEditar () {
      this.deshabilitaTerminal = false
      this.deshabilitaDescripcion = false
      this.deshabilitaUsuario = false
    }
  },
  ...mapGetters([
    'getlistUsersData',
    'getVisorTPVS'
  ]),
  computed: {
    listadoUsuarios () {
      let datosUsers = []
      if (this.$store.getters.getlistUsersData !== undefined) {
        if (this.$store.getters.getlistUsersData !== '') {
          datosUsers = this.$store.getters.getlistUsersData
          datosUsers.forEach(element => {
            element.nomcompleto = (element.nombre) + ' ' + (element.apelli1) + ' ' + (element.apelli2)
          })
        }
      }
      return datosUsers
    },
    listCodterm () {
      let datosCodterm = []
      if (this.$store.getters.getVisorTPVS !== undefined) {
        if (this.$store.getters.getVisorTPVS !== '') {
          datosCodterm = this.$store.getters.getVisorTPVS
        }
      }
      return datosCodterm
    }
  },
  components: {
    DialogGenericError,
    'dialog-generic-success': DialogConfirmSuccess,
    'dialog-generic-warning': DialogGenericWarning
  }
}
</script>

<style lang="scss" scoped>
    .prue {
    text-align: right;
    font-size: 9px;
    color: #6E767D;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: block;
    letter-spacing: .5px;
    float: left;
    line-height: 16px;
    margin-bottom: 8px;
    font-weight: 500;
    }
/deep/  .ods-dialog__header {
    padding: 0px 0 16px;
    }
/deep/  .ods-dialog__footer {
    padding: 55px 0 4px;
    text-align: right;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    }
/deep/  .ods-form-item__label {
    text-align: left;
    font-size: 9px;
    color: #6E767D;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: block;
    letter-spacing: .5px;
    float: unset;
    line-height: 16px;
    margin-bottom: 8px;
    }
    .detalle-usarioa-al {
    color: #060E14;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
  }
  .text-button {
    color: #2E6C99;
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 16px;
    text-align: right;
    cursor: pointer;
  }
</style>
